module.exports = __webpack_public_path__ + "static/xcode-09be08dff32945978e89c7c86f86a046.svg";